// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1OFqI","footer":"ModalUpdate_footer__1XYVs"};